import update from 'immutability-helper'
import { memo, useCallback, useState, useEffect } from 'react'
import { useDrop } from 'react-dnd'
import { Card } from './Card.js'
import { ItemTypes } from '../ItemTypes.js'
const style = {
  width: "50%",
}

const Container = memo(function Container(props) {
  const { subOneItems, hanldeModalSubsOpen } = props
  const [cards, setCards] = useState([])

  // const subOneItems = [
  //   {
  //     id: 1,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 2,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 3,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 4,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 5,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 6,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 7,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 8,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 9,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 10,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 11,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 12,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 13,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 14,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 15,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 16,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 17,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 18,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 19,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 20,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 21,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 22,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 23,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 24,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 25,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 26,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 27,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 28,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 29,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 30,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 31,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 32,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 33,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 34,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 35,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 36,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 37,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 38,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 39,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 40,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 41,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 42,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 43,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 44,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 45,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 46,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 47,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 48,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 49,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 50,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 51,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 52,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 53,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 54,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 55,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 56,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 57,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 58,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 59,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 60,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 61,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 62,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 63,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 64,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 65,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 66,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 67,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 68,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 69,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 70,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 71,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 72,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 73,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 74,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 75,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 76,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 77,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 78,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 79,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 80,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 81,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 82,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 83,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 84,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 85,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 86,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 87,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 88,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 89,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 90,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 91,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 92,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 93,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 94,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 95,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 96,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 97,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 98,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 99,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 100,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 101,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 102,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 103,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 104,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 105,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 106,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 107,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 108,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 109,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 110,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 111,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 112,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 113,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 114,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 115,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 116,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 117,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 118,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 119,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 120,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 121,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 122,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 123,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 124,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 125,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 126,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 127,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 128,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 129,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 130,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 131,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 132,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 133,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 134,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 135,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 136,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 137,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 138,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 139,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 140,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 141,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 142,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 143,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 144,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 145,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 146,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 147,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 148,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 149,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 150,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 151,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 152,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 153,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 154,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 155,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 156,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 157,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 158,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 159,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 160,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 161,
  //     startTime:1,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 162,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 163,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 164,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 165,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 166,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 167,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 168,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 169,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 170,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 171,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 172,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 173,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 174,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 175,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 176,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 177,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 178,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 179,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 180,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },{
  //     id: 181,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 182,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   },
  //   {
  //     id: 183,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'یار دبساتینی من',
  //   },
  //   {
  //     id: 184,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'ب سیب5سیب54 س5یب سیب5 4',
  //   },
  //   {
  //     id: 185,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'سیب سی5ب4 س5ب 4س6ب 46',
  //   },
  //   {
  //     id: 186,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '6666666666666666666666',
  //   },
  //   {
  //     id: 187,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: '77777777777777777',
  //   },
  //   {
  //     id: 188,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'کتاب خوانی \n saddasdasd',
  //   },
  //   {
  //     id: 189,
  //     startTime:1,
  //     startSeconds:1,
  //     endTime:2,
  //     endSeconds:2,
  //     text: 'انیرب سیبنتانتیب اسنتیبا نسیب',
  //   }
  // ]


  const [, drop] = useDrop(() => ({ accept: ItemTypes.CARD }))


  useEffect(() => {
    if (subOneItems) setCards(subOneItems)
  }, [subOneItems])
  return (
    <div ref={drop} style={style}>
      {cards.map((card, cardIndex) => (
        <div id="amnooi" style={{ height: "50px" }} key={`sub-${cardIndex}`}>
          <Card
            key={card.id}
            id={`${card.id}`}
            text={card.text}
            startSeconds={card.startSeconds}
            endSeconds={card.endSeconds}
            hanldeModalSubsOpen={hanldeModalSubsOpen}
            // moveCard={moveCard}
            // findCard={findCard}
            cardIndex={cardIndex}
          // insertNewCard={insertNewCard}
          // deleteCard={deleteCard}
          // changeCardText={changeCardText}
          // pasteTop={pasteTop}
          // pasteDown={pasteDown}
          // replaceText={replaceText}
          />
        </div>

      ))}
    </div>
  )
})


export default Container
